<div id="overlay-controller" *ngIf="visible">
    <div class="progress" style="height:10px">        
        <div class="progress-bar" [style.width.%]="audioProgress" style="height:10px"></div>
    </div>
    <div class="btn-center">
        <app-audio-skip-back-button [disabled]="skipBackState.disabled"></app-audio-skip-back-button>
        <app-audio-play-pause-button [disabled]="playPauseButtonState.disabled" [showPlayButton]="showPlayButton"></app-audio-play-pause-button>
        <app-audio-skip-forward-button [disabled]="skipForwardState.disabled"></app-audio-skip-forward-button>
    </div>   
</div>
